import { BaseVideoPlayer, PlayState } from '@envato/react-video'
import get from 'lodash-es/get'
import * as React from 'react'

import { formatClassfication } from '../../../common/utils/searchResultFormator'
import { IItem } from '../../../typings/searchResults'
import Magnifier from './magnifier'

const MagnifierConfigurator = ({
  item,
  videoMuted,
  muteVideo
}: {
  item: IItem
  videoMuted?: boolean
  muteVideo?: () => void
}) => {
  const previews = item.previews
  const formattedClassifcation = formatClassfication(item.classification)

  const getMagnifier = () => {
    const squarePreview = previews.icon_with_square_preview
    if (squarePreview && squarePreview.square_url) {
      return (
        <Magnifier
          name={item.name}
          authorName={item.author_username}
          priceInCents={item.price_cents}
          classification={formattedClassifcation}
          width={300}
          height={300}
        >
          <img alt={get(item, 'description')} src={squarePreview.square_url} />
        </Magnifier>
      )
    }

    const thumbnailPreview = previews.icon_with_thumbnail_preview
    if (thumbnailPreview && thumbnailPreview.thumbnail_url) {
      const width = thumbnailPreview.thumbnail_width || 300
      const height = thumbnailPreview.thumbnail_height || 300
      return (
        <Magnifier
          name={item.name}
          authorName={item.author_username}
          priceInCents={item.price_cents}
          classification={formattedClassifcation}
          width={width}
          height={height}
        >
          <img
            alt={get(item, 'description')}
            src={thumbnailPreview.thumbnail_url}
          />
        </Magnifier>
      )
    }

    const videoPreview = previews.icon_with_video_preview
    if (videoPreview && videoPreview.video_url) {
      return (
        <Magnifier
          name={item.name}
          authorName={item.author_username}
          priceInCents={item.price_cents}
          classification={formattedClassifcation}
          width={477}
          height={264}
        >
          <BaseVideoPlayer
            playState={PlayState.PLAY}
            muteVideo={muteVideo}
            loop
            muted={videoMuted}
            preload="none"
            src={videoPreview.video_url}
            poster={videoPreview.landscape_url}
          />
        </Magnifier>
      )
    }

    const landscapePreview = previews.icon_with_landscape_preview
    if (landscapePreview && landscapePreview.landscape_url) {
      return (
        <Magnifier
          name={item.name}
          authorName={item.author_username}
          priceInCents={item.price_cents}
          classification={formattedClassifcation}
          width={477}
          height={240}
        >
          <img
            alt={get(item, 'description')}
            src={landscapePreview.landscape_url}
          />
        </Magnifier>
      )
    }

    const audioPreview = previews.icon_with_audio_preview
    if (audioPreview) {
      return (
        <Magnifier
          name={item.name}
          authorName={item.author_username}
          priceInCents={item.price_cents}
          classification={formattedClassifcation}
          width={350}
        />
      )
    }

    return null
  }

  return <div className="fds-u-hide-small-and-below">{getMagnifier()}</div>
}

export default MagnifierConfigurator
